import { CollectionCodeEntryCard } from '@/features/order/ui/collection-code-modal'
import classes from './CollectionCodeTutorialOverlay.module.css'

export function CollectionCodeTutorialOverlay() {
  return (
    <div className={classes.overlay}>
      <div
        className={classes.panel}
      >
        <CollectionCodeEntryCard
          code="8573"
          disabled={true}
          dataOnboarding="tutorial-collection-code-card"
        />
      </div>
    </div>
  )
}
